import { useTenant } from '../../tenant/useTenant'
import { cn } from '../../utils/cn'
import { effectivePrice, formatPrice } from '../../utils/format'
import type { Service } from '../../types/storefront'


export interface ServicePriceProps {
  service: Service
  className?: string
}

export function ServicePrice({ service, className }: ServicePriceProps) {
  const { bootstrap } = useTenant()
  const { currency } = bootstrap
  const discounted = service.discounted_price !== null

  return (
    <span className={cn('inline-flex items-baseline gap-2', className)}>
      <span className="font-body-lg text-body-lg text-on-surface">
        {formatPrice(effectivePrice(service), currency)}
      </span>
      {discounted && (
        <span className="font-body-md text-body-md text-on-surface-variant line-through">
          {formatPrice(service.price, currency)}
        </span>
      )}
    </span>
  )
}
